import { axiosMock, hasUrlMock } from '../client';
import {
  createClinicalTrialInventoryScoringFormsList,
  createClinicalTrialInventoryInstrumentList,
  createClinicalTrialInventoryMeasurementsList,
} from 'src/mocks/clinicalTrialInventory';
import { prepareUrl } from 'src/utils/routerHelpers';
import { API_URL } from '../apiDictionary';
import { ClinicalTrialInventoryType } from '@dynamika-shared/types/clinicalTrialInventory';

export const fetchClinicalTrialInventoryMock = async (id: string) => {
  if (!hasUrlMock(API_URL.clinicalTrialInventory)) {
    return;
  }
  const scoringForms = createClinicalTrialInventoryScoringFormsList();
  const measurements = createClinicalTrialInventoryMeasurementsList();
  const instruments = createClinicalTrialInventoryInstrumentList();

  const data: Partial<ClinicalTrialInventoryType> = {
    scoringForms,
    measurements,
    instruments,
  };

  axiosMock
    .onGet(prepareUrl(API_URL.clinicalTrialInventory, [id]))
    .reply(200, data);
};
